module.exports = __webpack_public_path__ + "static/media/mcmaster-logo.55002bc2.svg";